// Only fixed action metadata is emitted, after the existing analytics consent check.
// Never pass form state, client identifiers, URLs or monetary values here.
export const useWorkflowToolTracking = (page: string) => {
  const { consent } = useCookieConsent();
  return (action: 'sample_load' | 'add_row' | 'export_all' | 'export_filtered' | 'print_open' | 'prepare' | 'copy' | 'download_blank' | 'download_example' | 'download_text') => {
    if (!import.meta.client || !consent.value?.analytics) return;
    const payload = { page, action, version: '1' };
    if (typeof window.gtag === 'function') window.gtag('event', 'workflow_tool_action', payload);
    else (window.dataLayer ||= []).push({ event: 'workflow_tool_action', ...payload });
  };
};
